var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.0008,
    cy: 98.9999,
    r: 98.4,
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 198,
    height: 198
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.0008,
    cy: 98.9999,
    r: 98.4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4005 111.4C122.007 111.4 140.334 93.0731 140.334 70.4663C140.334 47.8594 122.007 29.533 99.4005 29.533C76.7937 29.533 58.4672 47.8594 58.4672 70.4663C58.4672 93.0731 76.7937 111.4 99.4005 111.4Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.269 183.033V193.266C181.269 195.98 180.191 198.583 178.272 200.502C176.353 202.422 173.75 203.5 171.036 203.5H27.7693C25.0552 203.5 22.4524 202.422 20.5332 200.502C18.6141 198.583 17.536 195.98 17.536 193.266V183.033C17.536 166.749 24.0049 151.131 35.5196 139.617C47.0343 128.102 62.6517 121.633 78.936 121.633H119.869C136.154 121.633 151.771 128.102 163.286 139.617C174.8 151.131 181.269 166.749 181.269 183.033Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5805,
    cy: 66.1999,
    rx: 7.57895,
    ry: 9.6,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.843,
    cy: 66.1999,
    rx: 7.57895,
    ry: 9.6,
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.8fd9c91bd0d3329c5373e4740ab105d5.svg";
export { ForwardRef as ReactComponent };